"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

// Header
// ======
//
// As in not the main header at the top of the page. Heading should be a h1,
// subheading = h2. Otherwise, supply custom-styled child elements.
var Header = function Header(props) {
  return _react["default"].createElement("header", {
    className: (0, _classnames["default"])(_index["default"].Header, _index["default"][props.align])
  }, props.image && _react["default"].createElement("img", {
    src: props.image,
    className: _index["default"].image
  }), props.children);
};

Header.propTypes = {
  image: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(['left', 'right', 'center']),
  children: _propTypes["default"].node
};
Header.defaultProps = {
  align: 'center'
};
var _default = Header;
exports["default"] = _default;